import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import routes from '../sidebar/menu';

function setTitle(path, routeArray) {
    let pageTitle;
    for (var i = 0; i < routeArray.length; i++) {
        if (routeArray[i].children) {
            for (var j = 0; j < routeArray[i].children.length; j++) {
                //let childrenPath = routeArray[i].children[j].path;
                //if (childrenPath.indexOf('/create') > -1) childrenPath = childrenPath.replace('/create', '');
                if (routeArray[i].children[j].path === path) pageTitle = routeArray[i].children[j].title;
                //if (childrenPath === path) pageTitle = routeArray[i].children[j].title;
            }       
        } else {
            if (routeArray[i].path === path) pageTitle = routeArray[i].title;
        }
    }
    document.title = (pageTitle) ? 'KARAedu Admin | ' + pageTitle : 'KARAedu Admin';
}

class Content extends React.Component {

    componentDidMount() {
        setTitle(this.props.history.location.pathname, routes);
        this.props.history.listen(() => {
            setTitle(this.props.history.location.pathname, routes);
        });
    }

    render() {
        return (
            <div className={'content ' + (this.props.content.pageContentFullWidth ? 'content-full-width ' : '' + this.props.content.pageContentClass)}>
                {this.props.children}
            </div>
        )
    }
}

export default connect(
    state => ({ content: state.content }),
    null
)(withRouter(Content));




// WEBPACK FOOTER //
// ./src/components/admin/content/content.js